module.exports = "<a *ngFor=\"let resource of supportedResources\" routerLink=\"/resources/{{resource}}\" mat-list-item>{{resource}}</a>"